import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    Row,
    Col,
    Image,
    Form,
    Button,
    Spinner,
    FormCheck,
} from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import axios from "axios";
import { DatePicker, Space } from "antd";
import { getDay, getMonth, getYear, isValid } from "date-fns";
import Cookies from "js-cookie";

const ManageBrand = (props) => {
    const BrandRouteId = useParams();
    const navigate = useNavigate();
    const token = Cookies.get("token");

    const [Permissions, setPermissions] = useState(
        Util.decrypt(localStorage.getItem("rpmRRTLx12"))
    );

    const [brandId, setBrandId] = useState(
        Number(BrandRouteId.BrandRouteId) || 0
    );

    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    const [brandExist, setBrandExist] = useState(null);
    const [brandDetails, setBrandDetails] = useState({
        BrandId: 0,
        BrandName: "",
        Logo: "",
        Link: "",
        ImageAlt: "",
        isDeleted: true,
    });
    const [image, setImage] = useState("");
    const [Logo, setLogo] = useState("");

    // get Brand details
    const GetBrandDetails = async () => {
        let response = await fetch(
            Variables.API_URL + "Brand/GetBrandDetails/" + brandId,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        let result = await response.json();
        if (response.status === 200) {
            setBrandDetails({
                BrandId: result.BrandId,
                BrandName: result.BrandName,
                Link: result.Link,
                ImageAlt: result.ImageAlt,
                Logo: result.Logo,
                isDeleted: result.isDeleted
            });

            setBrandExist(true);
        } else {
            setBrandExist(false);
        }
    };
    // handle Inputs
    const handleInputs = (e) => {
        const { name, value } = e.target;
        var element;
        if (value === "" || value === "0") {
            element = document.getElementById(name);
            element.classList.add("is-invalid");
        } else {
            element = document.getElementById(name);
            element.classList.remove("is-invalid");
        }
        setBrandDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Set Image
    const SetImage = (e) => {
        var x = e.target.files[0];
        let reader = new FileReader();
        reader.onload = function (e) {
            if (
                e.target.result.indexOf("png") >= 0 ||
                e.target.result.indexOf("jpeg") >= 0 ||
                e.target.result.indexOf("jpg") >= 0
            ) {
                setLogo(x);
                setImage(e.target.result);
            } else {
                toast.error("File type error", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        };
        reader.readAsDataURL(e.target.files[0]);
        var element = document.getElementById("ImageUrl");
        element.classList.remove("is-invalid");
    };
      // Handle IsPublished
  const HandleIsPublished = () => {
    if (brandDetails.isDeleted === true) {
      setBrandDetails((prevState) => ({
        ...prevState,
        isDeleted: false,
      }));
    } else {
      setBrandDetails((prevState) => ({
        ...prevState,
        isDeleted: true,
      }));
    }
  };
  // Check input validity
  function IsValid() {
    var hasError = false;
    var element;
    if (brandDetails.BrandName === null || brandDetails.BrandName === "") {
      element = document.getElementById("BrandName");
      element.classList.add("is-invalid");
      element.focus();
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }
  const AddNewBrand = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Brand/AddNewBrand", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        BrandId: brandDetails.BrandId,
        BrandName: brandDetails.BrandName,
        Logo: "",
        Link: brandDetails.Link,
        ImageAlt: brandDetails.ImageAlt,
        isDeleted: brandDetails.isDeleted
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success("Brand Added Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      if(Logo != ""){
        const formData = new FormData();
        formData.append("Logo", Logo);
        formData.append("BrandId", result);
  
        const resImage = await axios.post(
          Variables.API_URL + "Brand/UploadBrandMedia",
          formData,{
            headers:{
              Authorization: `Bearer ${token}`,
            }
          }
        );
      }

      setTimeout(() => {
        navigate("/Brand");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Update Brand
  const UpdateBrand = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Brand/UpdateBrand", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        BrandId: brandDetails.BrandId,
        BrandName: brandDetails.BrandName,
        Logo: "",
        Link: brandDetails.Link,
        ImageAlt: brandDetails.ImageAlt,
        isDeleted: brandDetails.isDeleted
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      if (Logo != "") {
        
        const formData = new FormData();
        formData.append("Logo", Logo);
        formData.append("BrandId", brandId);

        const resImage = await axios.post(
          Variables.API_URL + "Brand/UploadBrandMedia",
          formData,{
            headers:{
              Authorization: `Bearer ${token}`,
            }
          }
        );
      }
      setTimeout(() => {
        navigate("/Brand");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };
  const HandleSumbit = async () => {
    var isValid = IsValid();
    if (isValid) {
      if (brandId === 0) {
        AddNewBrand();
      }
      else {
        UpdateBrand();
      }
    } else {
      toast.error("Please Fill All Required Fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    
      if (brandId != 0) {
        GetBrandDetails();
      }
  }, []);

    return (
        <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {brandId === 0
                    ? "Add New Brand"
                    : "Manage Brand --> " + brandDetails.BrandName}
                </h4>
              </div>
            </Card.Header>
            <Card.Body>
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div>
                  <Row>
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">BrandName :</Form.Label>
                      <Form.Control
                        id="BrandName"
                        name="BrandName"
                        placeholder="BrandName"
                        type="text"
                        value={brandDetails.BrandName}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Link :</Form.Label>
                      <Form.Control
                        id="Link"
                        name="Link"
                        placeholder="Link"
                        type="text"
                        value={brandDetails.Link}
                        onChange={handleInputs}
                      />
                    </Form.Group>
                    <Form.Group className="col-md-3 form-group">
                      <Form.Label htmlFor="fname">.</Form.Label>
                      <Form.Check className="mb-3 form-check">
                        <FormCheck.Input
                          type="checkbox"
                          className=""
                          id="Published"
                          checked={brandDetails.isDeleted}
                          onChange={(e) => HandleIsPublished()}
                        />
                        <FormCheck.Label className="" htmlFor="exampleCheck1">
                          IsPublished
                        </FormCheck.Label>
                      </Form.Check>
                    </Form.Group>

            

                    <Form.Group className="col-lg-6 col-md-12 col-sm-12 form-group">
                      <Row>
                        <Form.Group>
                          <Form.Label className="custom-file-input">
                            Choose Image
                          </Form.Label>
                          <Form.Control
                            id="ImageUrl"
                            name="ImageUrl"
                            placeholder="Image"
                            type="file"
                            accept="image/*"
                            onChange={SetImage}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Col className="allignCenter">
                          {image !== "" ? (
                            <div>
                              <img
                                src={image}
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : brandDetails.Logo !== "" &&
                            brandDetails.Logo !== null ? (
                            <div>
                              <img
                                src={
                                  Variables.imagePath + brandDetails.Logo
                                }
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="ImageAlt">Image Alt :</Form.Label>
                      <Form.Control
                        id="ImageAlt"
                        name="ImageAlt"
                        placeholder="Image Alt"
                        type="text"
                        value={brandDetails.ImageAlt}
                        onChange={handleInputs}
                      />
                    </Form.Group>
                  </Row>
                </div>
              )}
              <hr />

              <div className="float-right">
                <Button
                  type="button"
                  variant="btn btn-primary"
                  onClick={HandleSumbit}
                >
                  {buttonLoader == true ? (
                    <Spinner animation="border" variant="light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    "Submit"
                  )}
                </Button>{" "}
                <Button
                  type="button"
                  variant="btn btn-secondary"
                  onClick={() => navigate("/Brand")}
                >
                  Cancel
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
    );
}
export default ManageBrand;